document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    const revisitWrapper = document.querySelector(".cky-btn-revisit-wrapper");
    const siteFooter = document.querySelector(".site-footer");

    if (revisitWrapper && siteFooter) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              revisitWrapper.classList.remove("cky-hidden");
              revisitWrapper.classList.add("cky-shown");
            } else {
              revisitWrapper.classList.remove("cky-shown");
              revisitWrapper.classList.add("cky-hidden");
            }
          });
        },
        {
          root: null,
          threshold: 0,
        }
      );

      observer.observe(siteFooter);
    }
  }, 3000);
});
